<template src="../templates/normal_fcont_192.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import PrintButton from '../components/PrintButton'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '192',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,PrintButton,Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadCreative
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['192-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['192-3']}
    ]};

  }
};
</script>
<style scoped>
</style>

